export const apiUrl = "https://restcountries.com/v3.1";